module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-be85fd38bf7834a469d3814fc6e72a39.png";